/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Frame_Forward_Aria_LabelInputs */

const en_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame Forward`)
};

const fr_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image Suivante`)
};

const de_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame Forward`)
};

const it_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame in avanti`)
};

const ru_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кадровое движение вперед`)
};

const es_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco hacia adelante`)
};

const zh_cn2_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧前`)
};

const ja_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレームフォワード`)
};

const hi_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम आगे`)
};

const pt_pt2_player_frame_forward_aria_label = /** @type {(inputs: Player_Frame_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro frontal`)
};

/**
* | output |
* | --- |
* | "Frame Forward" |
*
* @param {Player_Frame_Forward_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_frame_forward_aria_label = /** @type {((inputs?: Player_Frame_Forward_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Frame_Forward_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_frame_forward_aria_label(inputs)
	if (locale === "de") return de_player_frame_forward_aria_label(inputs)
	if (locale === "it") return it_player_frame_forward_aria_label(inputs)
	if (locale === "ru") return ru_player_frame_forward_aria_label(inputs)
	if (locale === "es") return es_player_frame_forward_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_frame_forward_aria_label(inputs)
	if (locale === "ja") return ja_player_frame_forward_aria_label(inputs)
	if (locale === "hi") return hi_player_frame_forward_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_frame_forward_aria_label(inputs)
	return en_player_frame_forward_aria_label(inputs)
});